export enum MainSection {
  Patient,
  Vademecum,
  Institution
}